import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, switchMap, tap } from 'rxjs/operators'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { FormulaValueApiService } from '../../../api/product/formula-value'
import { createFormulaValue, createFormulaValueFailure, createFormulaValueSuccess, deleteFormulaValue, deleteFormulaValueFailure, deleteFormulaValueSuccess, loadFormulaValues, loadFormulaValuesFailure, loadFormulaValuesSuccess, updateFormulaValue, updateFormulaValueFailure, updateFormulaValueSuccess } from './formula-values.actions'

@Injectable()
export class FormulaValueEffects {
  private actions$ = inject(Actions)
  private FormulaValueApi = inject(FormulaValueApiService)
  private toaster = inject(ToasterService)


  loadFormulaValues$ = createEffect(() => this.actions$.pipe(
    ofType(loadFormulaValues),
    switchMap(() =>
      this.FormulaValueApi.list().pipe(
        map(formulaValues => loadFormulaValuesSuccess({ formulaValues })),
        catchAndLog(this.toaster, 'Unable to fetch formulaValues', loadFormulaValuesFailure)))))

  createFormulaValue$ = createEffect(() => this.actions$.pipe(
    ofType(createFormulaValue),
    tap(() => this.toaster.progress('Creating formula value...')),
    switchMap(action =>
      this.FormulaValueApi.create(action.formulaValue).pipe(
        map(formulaValue => createFormulaValueSuccess({ formulaValue })),
        tap(() => this.toaster.success('Formula value created successfully.')),
        catchAndLog(this.toaster, 'Unable to create formula value', createFormulaValueFailure)))))

  updateFormulaValue$ = createEffect(() => this.actions$.pipe(
    ofType(updateFormulaValue),
    tap(() => this.toaster.progress('Updating formula value...')),
    switchMap(action =>
      this.FormulaValueApi.update(action.id, action.formulaValue).pipe(
        map(formulaValue => updateFormulaValueSuccess({ formulaValue })),
        tap(() => this.toaster.success('Formula value updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update formula value', updateFormulaValueFailure)))))

  deleteFormulaValue$ = createEffect(() => this.actions$.pipe(
    ofType(deleteFormulaValue),
    tap(() => this.toaster.progress('Deleting formula value...')),
    switchMap(action =>
      this.FormulaValueApi.delete(action.id).pipe(
        map(() => deleteFormulaValueSuccess({ id: action.id })),
        tap(() => this.toaster.success('Formula value deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete formula value', deleteFormulaValueFailure)))))
}
